module.exports = __webpack_public_path__ + "img/submit-hen.5bbf2512.png";